// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  /* Colors */
  --primary-color: #3483fa;
  /* Mercado Livre Blue */
  --secondary-color: #ffe600;
  /* Mercado Livre Yellow */
  --accent-color: #00a650;
  /* Green for success/discounts */
  --danger-color: #ff3b3c;
  /* Red for errors/hot deals */
  --text-primary: #333333;
  --text-secondary: #666666;
  --background-light: #f5f5f5;
  --white: #ffffff;
  --border-color: #e0e0e0;

  /* Typography */
  --font-family: 'Proxima Nova', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
  --font-size-base: 16px;
  --font-size-sm: 14px;
  --font-size-lg: 18px;
  --font-size-xl: 24px;

  /* Spacing */
  --spacing-xs: 4px;
  --spacing-sm: 8px;
  --spacing-md: 16px;
  --spacing-lg: 24px;
  --spacing-xl: 32px;

  /* Shadows */
  --shadow-sm: 0 1px 2px 0 rgba(0, 0, 0, 0.1);
  --shadow-md: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  --shadow-lg: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);

  /* Border Radius */
  --radius-sm: 4px;
  --radius-md: 8px;
  --radius-lg: 12px;
}

* {
  box-sizing: border-box;
}

body {
  margin: 0;
  font-family: var(--font-family);
  background-color: var(--background-light);
  color: var(--text-primary);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  line-height: 1.5;
}

a {
  text-decoration: none;
  color: inherit;
}

ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

button {
  cursor: pointer;
  font-family: inherit;
}

/* Container Utility */
.container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 var(--spacing-md);
}

/* Grid Utility */
.grid {
  display: grid;
  gap: var(--spacing-md);
}

.grid-cols-1 {
  grid-template-columns: repeat(1, 1fr);
}

.grid-cols-2 {
  grid-template-columns: repeat(2, 1fr);
}

.grid-cols-3 {
  grid-template-columns: repeat(3, 1fr);
}

.grid-cols-4 {
  grid-template-columns: repeat(4, 1fr);
}

.grid-cols-5 {
  grid-template-columns: repeat(5, 1fr);
}

/* Responsive Breakpoints */
@media (min-width: 640px) {
  .grid-sm-2 {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (min-width: 768px) {
  .grid-md-2 {
    grid-template-columns: repeat(2, 1fr);
  }

  .grid-md-3 {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (min-width: 1024px) {
  .grid-lg-3 {
    grid-template-columns: repeat(3, 1fr);
  }

  .grid-lg-4 {
    grid-template-columns: repeat(4, 1fr);
  }
}

@media (min-width: 1400px) {
  .grid-xl-5 {
    grid-template-columns: repeat(5, 1fr);
  }
}
/* Offer Sections */
.offer-section {
  margin-bottom: var(--spacing-xl);
  width: 100%;
}

.offer-section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: var(--spacing-sm);
  padding: 0 var(--spacing-md);
}

.offer-section-title {
  font-size: var(--font-size-xl);
  font-weight: 700;
  color: var(--text-primary);
  margin: 0;
}

.offer-section-carousel-container {
  position: relative;
  width: 100%;
}

.offer-section-grid {
  display: flex;
  overflow-x: auto;
  gap: var(--spacing-md);
  padding: 15px var(--spacing-md);
  scrollbar-width: none;
  -ms-overflow-style: none;
  scroll-behavior: smooth;
}

.offer-section-grid::-webkit-scrollbar {
  display: none;
}

.offer-section-grid > * {
  flex: 0 0 250px;
  min-width: 250px;
}

@media (min-width: 1024px) {
  .offer-section-carousel-container {
     padding: 0 40px; /* Reservar espaço lateral */
  }

  .offer-section-grid {
    padding: 15px 0;
  }

  /* Exibir exatamente 5 itens por vez no desktop */
  .offer-section-grid > * {
    flex: 0 0 calc(20% - (var(--spacing-md) * 4 / 5));
    min-width: 180px;
  }

  .offer-section-header {
    padding: 0 40px;
  }
}

.carousel-arrow {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: white;
  border: none;
  box-shadow: 0 4px 12px rgba(0,0,0,0.15);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 11;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  color: var(--text-primary);
  visibility: hidden; /* Oculto por padrão, visivel se hover no container */
  opacity: 0;
}

.offer-section-carousel-container:hover .carousel-arrow {
  visibility: visible;
  opacity: 1;
}

.carousel-arrow:hover {
  background: var(--primary-color);
  color: white;
  transform: translateY(-50%) scale(1.1);
  box-shadow: 0 6px 16px rgba(0,0,0,0.2);
}

.carousel-arrow-left {
  left: 10px;
}

.carousel-arrow-right {
  right: 10px;
}

.view-all-btn {
  color: var(--primary-color);
  background: none;
  border: none;
  font-weight: bold;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 4px;
  transition: opacity 0.2s;
}

.view-all-btn:hover {
  opacity: 0.7;
}

/* View All Card in Carousel */
.view-all-card:hover {
  border-color: var(--primary-color) !important;
  transform: translateY(-5px);
  box-shadow: var(--shadow-md);
  background-color: rgba(52, 131, 250, 0.02) !important;
}

.view-all-card:active {
  transform: scale(0.95);
}

@media (max-width: 768px) {
  .carousel-arrow {
    display: none; /* Mobile usa scroll natural */
  }
  
  .offer-section-carousel-container {
    padding: 0;
  }

  .offer-section-header {
    padding: 0 var(--spacing-md);
  }
}

/* Breadcrumbs Section */
.breadcrumb-container {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  font-size: 13px;
}

.breadcrumb-item {
  color: var(--text-secondary);
  cursor: pointer;
  transition: all 0.2s ease;
  padding: 2px 4px;
  border-radius: 4px;
  text-decoration: none;
}

.breadcrumb-item:hover {
  color: var(--primary-color);
  background-color: rgba(52, 131, 250, 0.1);
}

.breadcrumb-separator {
  color: #ccc;
  font-size: 10px;
}

`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,wBAAwB;EACxB,uBAAuB;EACvB,0BAA0B;EAC1B,yBAAyB;EACzB,uBAAuB;EACvB,gCAAgC;EAChC,uBAAuB;EACvB,6BAA6B;EAC7B,uBAAuB;EACvB,yBAAyB;EACzB,2BAA2B;EAC3B,gBAAgB;EAChB,uBAAuB;;EAEvB,eAAe;EACf,0JAA0J;EAC1J,sBAAsB;EACtB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;;EAEpB,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;;EAElB,YAAY;EACZ,2CAA2C;EAC3C,kFAAkF;EAClF,oFAAoF;;EAEpF,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,+BAA+B;EAC/B,yCAAyC;EACzC,0BAA0B;EAC1B,mCAAmC;EACnC,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,eAAe;EACf,oBAAoB;AACtB;;AAEA,sBAAsB;AACtB;EACE,iBAAiB;EACjB,cAAc;EACd,4BAA4B;AAC9B;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA,2BAA2B;AAC3B;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;;EAEA;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;;EAEA;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;AACA,mBAAmB;AACnB;EACE,gCAAgC;EAChC,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gCAAgC;EAChC,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,0BAA0B;EAC1B,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,sBAAsB;EACtB,+BAA+B;EAC/B,qBAAqB;EACrB,wBAAwB;EACxB,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE;KACG,eAAe,EAAE,4BAA4B;EAChD;;EAEA;IACE,eAAe;EACjB;;EAEA,iDAAiD;EACjD;IACE,iDAAiD;IACjD,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;EACZ,uCAAuC;EACvC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,WAAW;EACX,iDAAiD;EACjD,0BAA0B;EAC1B,kBAAkB,EAAE,qDAAqD;EACzE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,gCAAgC;EAChC,YAAY;EACZ,sCAAsC;EACtC,sCAAsC;AACxC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,wBAAwB;AAC1B;;AAEA;EACE,YAAY;AACd;;AAEA,8BAA8B;AAC9B;EACE,6CAA6C;EAC7C,2BAA2B;EAC3B,4BAA4B;EAC5B,qDAAqD;AACvD;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE;IACE,aAAa,EAAE,8BAA8B;EAC/C;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,4BAA4B;EAC9B;AACF;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,4BAA4B;EAC5B,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,eAAe;AACjB","sourcesContent":[":root {\r\n  /* Colors */\r\n  --primary-color: #3483fa;\r\n  /* Mercado Livre Blue */\r\n  --secondary-color: #ffe600;\r\n  /* Mercado Livre Yellow */\r\n  --accent-color: #00a650;\r\n  /* Green for success/discounts */\r\n  --danger-color: #ff3b3c;\r\n  /* Red for errors/hot deals */\r\n  --text-primary: #333333;\r\n  --text-secondary: #666666;\r\n  --background-light: #f5f5f5;\r\n  --white: #ffffff;\r\n  --border-color: #e0e0e0;\r\n\r\n  /* Typography */\r\n  --font-family: 'Proxima Nova', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;\r\n  --font-size-base: 16px;\r\n  --font-size-sm: 14px;\r\n  --font-size-lg: 18px;\r\n  --font-size-xl: 24px;\r\n\r\n  /* Spacing */\r\n  --spacing-xs: 4px;\r\n  --spacing-sm: 8px;\r\n  --spacing-md: 16px;\r\n  --spacing-lg: 24px;\r\n  --spacing-xl: 32px;\r\n\r\n  /* Shadows */\r\n  --shadow-sm: 0 1px 2px 0 rgba(0, 0, 0, 0.1);\r\n  --shadow-md: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);\r\n  --shadow-lg: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);\r\n\r\n  /* Border Radius */\r\n  --radius-sm: 4px;\r\n  --radius-md: 8px;\r\n  --radius-lg: 12px;\r\n}\r\n\r\n* {\r\n  box-sizing: border-box;\r\n}\r\n\r\nbody {\r\n  margin: 0;\r\n  font-family: var(--font-family);\r\n  background-color: var(--background-light);\r\n  color: var(--text-primary);\r\n  -webkit-font-smoothing: antialiased;\r\n  -moz-osx-font-smoothing: grayscale;\r\n  line-height: 1.5;\r\n}\r\n\r\na {\r\n  text-decoration: none;\r\n  color: inherit;\r\n}\r\n\r\nul {\r\n  list-style: none;\r\n  padding: 0;\r\n  margin: 0;\r\n}\r\n\r\nbutton {\r\n  cursor: pointer;\r\n  font-family: inherit;\r\n}\r\n\r\n/* Container Utility */\r\n.container {\r\n  max-width: 1400px;\r\n  margin: 0 auto;\r\n  padding: 0 var(--spacing-md);\r\n}\r\n\r\n/* Grid Utility */\r\n.grid {\r\n  display: grid;\r\n  gap: var(--spacing-md);\r\n}\r\n\r\n.grid-cols-1 {\r\n  grid-template-columns: repeat(1, 1fr);\r\n}\r\n\r\n.grid-cols-2 {\r\n  grid-template-columns: repeat(2, 1fr);\r\n}\r\n\r\n.grid-cols-3 {\r\n  grid-template-columns: repeat(3, 1fr);\r\n}\r\n\r\n.grid-cols-4 {\r\n  grid-template-columns: repeat(4, 1fr);\r\n}\r\n\r\n.grid-cols-5 {\r\n  grid-template-columns: repeat(5, 1fr);\r\n}\r\n\r\n/* Responsive Breakpoints */\r\n@media (min-width: 640px) {\r\n  .grid-sm-2 {\r\n    grid-template-columns: repeat(2, 1fr);\r\n  }\r\n}\r\n\r\n@media (min-width: 768px) {\r\n  .grid-md-2 {\r\n    grid-template-columns: repeat(2, 1fr);\r\n  }\r\n\r\n  .grid-md-3 {\r\n    grid-template-columns: repeat(3, 1fr);\r\n  }\r\n}\r\n\r\n@media (min-width: 1024px) {\r\n  .grid-lg-3 {\r\n    grid-template-columns: repeat(3, 1fr);\r\n  }\r\n\r\n  .grid-lg-4 {\r\n    grid-template-columns: repeat(4, 1fr);\r\n  }\r\n}\r\n\r\n@media (min-width: 1400px) {\r\n  .grid-xl-5 {\r\n    grid-template-columns: repeat(5, 1fr);\r\n  }\r\n}\n/* Offer Sections */\n.offer-section {\n  margin-bottom: var(--spacing-xl);\n  width: 100%;\n}\n\n.offer-section-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: var(--spacing-sm);\n  padding: 0 var(--spacing-md);\n}\n\n.offer-section-title {\n  font-size: var(--font-size-xl);\n  font-weight: 700;\n  color: var(--text-primary);\n  margin: 0;\n}\n\n.offer-section-carousel-container {\n  position: relative;\n  width: 100%;\n}\n\n.offer-section-grid {\n  display: flex;\n  overflow-x: auto;\n  gap: var(--spacing-md);\n  padding: 15px var(--spacing-md);\n  scrollbar-width: none;\n  -ms-overflow-style: none;\n  scroll-behavior: smooth;\n}\n\n.offer-section-grid::-webkit-scrollbar {\n  display: none;\n}\n\n.offer-section-grid > * {\n  flex: 0 0 250px;\n  min-width: 250px;\n}\n\n@media (min-width: 1024px) {\n  .offer-section-carousel-container {\n     padding: 0 40px; /* Reservar espaço lateral */\n  }\n\n  .offer-section-grid {\n    padding: 15px 0;\n  }\n\n  /* Exibir exatamente 5 itens por vez no desktop */\n  .offer-section-grid > * {\n    flex: 0 0 calc(20% - (var(--spacing-md) * 4 / 5));\n    min-width: 180px;\n  }\n\n  .offer-section-header {\n    padding: 0 40px;\n  }\n}\n\n.carousel-arrow {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 44px;\n  height: 44px;\n  border-radius: 50%;\n  background: white;\n  border: none;\n  box-shadow: 0 4px 12px rgba(0,0,0,0.15);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  z-index: 11;\n  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n  color: var(--text-primary);\n  visibility: hidden; /* Oculto por padrão, visivel se hover no container */\n  opacity: 0;\n}\n\n.offer-section-carousel-container:hover .carousel-arrow {\n  visibility: visible;\n  opacity: 1;\n}\n\n.carousel-arrow:hover {\n  background: var(--primary-color);\n  color: white;\n  transform: translateY(-50%) scale(1.1);\n  box-shadow: 0 6px 16px rgba(0,0,0,0.2);\n}\n\n.carousel-arrow-left {\n  left: 10px;\n}\n\n.carousel-arrow-right {\n  right: 10px;\n}\n\n.view-all-btn {\n  color: var(--primary-color);\n  background: none;\n  border: none;\n  font-weight: bold;\n  font-size: 14px;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  transition: opacity 0.2s;\n}\n\n.view-all-btn:hover {\n  opacity: 0.7;\n}\n\n/* View All Card in Carousel */\n.view-all-card:hover {\n  border-color: var(--primary-color) !important;\n  transform: translateY(-5px);\n  box-shadow: var(--shadow-md);\n  background-color: rgba(52, 131, 250, 0.02) !important;\n}\n\n.view-all-card:active {\n  transform: scale(0.95);\n}\n\n@media (max-width: 768px) {\n  .carousel-arrow {\n    display: none; /* Mobile usa scroll natural */\n  }\n  \n  .offer-section-carousel-container {\n    padding: 0;\n  }\n\n  .offer-section-header {\n    padding: 0 var(--spacing-md);\n  }\n}\n\n/* Breadcrumbs Section */\n.breadcrumb-container {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 8px;\n  font-size: 13px;\n}\n\n.breadcrumb-item {\n  color: var(--text-secondary);\n  cursor: pointer;\n  transition: all 0.2s ease;\n  padding: 2px 4px;\n  border-radius: 4px;\n  text-decoration: none;\n}\n\n.breadcrumb-item:hover {\n  color: var(--primary-color);\n  background-color: rgba(52, 131, 250, 0.1);\n}\n\n.breadcrumb-separator {\n  color: #ccc;\n  font-size: 10px;\n}\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
